import React, { useEffect } from "react"
import { Table } from "reactstrap"
import SmallLoader from "../../../Common/SmallLoader"
import CustomLoader from "../../../Common/CustomLoader"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"

const tableHeader = [
  { title: "Date" },
  { title: "Invoice" },
  { title: "Amount" },
  { title: "Status" },
  { title: "Action" },
]
const tableData = [
  {
    title: "20 Sep 2023",
    invoice: "Inv - 00123",
    amount: "$ 99.00",
    status: "Paid",
  },
  {
    title: "20 Sep 2023",
    invoice: "Inv - 00123",
    amount: "$ 99.00",
    status: "Pending",
  },
  {
    title: "20 Sep 2023",
    invoice: "Inv - 00123",
    amount: "$ 99.00",
    status: "Overdue",
  },
]
const InvStatus = {
  open: "Pending",
  paid: "Paid",
  uncollectible: "Overdue",
}

const BillingHistory = ({ invList, invListLoading }) => {


  return (
    <div className="mt-3 billing-details-billingHist">
      <div className="title">Billing history</div>
      {invListLoading ? (
        <CustomLoader text={"Fetching invoices..."} />
      ) : !(invList && invList.count > 0) ? (
        <div className="no-data">
          <span>No data</span>
        </div>
      ) : (
        <div className="mt-3">
          <Table responsive className="table-custom m-0">
            <thead>
              <tr className="header">
                {tableHeader.map(title => (
                  <th className="title" key={Math.random()}>
                    {title.title}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {invList.invoice.map(td => (
                <tr className="data" key={td.id}>
                  <td className="title">{td.created}</td>
                  <td className="title">{td.number}</td>
                  <td className="title">{td?.amount_due || td?.amount_paid}</td>
                  <td className="title">
                    <span className={`status-${InvStatus[td.status]}`}>
                      {InvStatus[td.status]}
                    </span>
                  </td>
                  <td className="title">
                    {InvStatus[td.status] !== "Paid" ? <div>
                      <a className="button-table" target="_blank" href={td.hosted_invoice_url}>
                        Review and pay

                      </a>
                    </div>
                      :
                      <div>
                        <a className="button-table" target="_blank" href={td.hosted_invoice_url}>
                          View
                        </a>
                        <a
                          className="button-table button-left-margin"
                          href={td.invoice_pdf}
                        >
                          Download
                        </a>
                      </div>}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  )
}

export default BillingHistory
